import { commonTypes } from '../common';
import { types as flowTypes } from '../flow';
import { emptyStep } from '../../flowDefinition/commonSteps';

export const types = {
  SET_BLOCKED_UI_STEP: 'UINEEDS/SET_BLOCKED_UI_STEP',
  RESET_LAST_CONFIRMED_STEP: 'UINEEDS/RESET_LAST_CONFIRMED_STEP',
  SET_SHOW_STEP_ADVICE: 'UINEEDS/SET_SHOW_STEP_ADVICE',
};

export const initialState = {
  actualStep: emptyStep,
  blockedUIStep: false,
  confirmedSteps: [],
  stepAdvice: {
    mustShow: false,
    adviceTitle: null,
    stepsToShow: null,
  },
  flowInfo: {
    flowJson: null,
    flowJsonNumSteps: null,
    process: null,
    productOffering: null,
    promotion: null,
  },
};

const UINeedsStepsReducer = (state, action) => {
  switch (action.type) {
    case types.SET_BLOCKED_UI_STEP: {
      const newState = {
        ...state,
        blockedUIStep: action.payload,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_CONFIRMED_STEP: {
      const { confirmedStep } = action.payload;
      const { stepId, unblockedUIStep } = confirmedStep;

      if (state.confirmedSteps.includes(stepId)) {
        return {
          state: null,
          stepsMustBeEvaluated: false,
        };
      }

      const newConfirmedSteps = [
        ...state.confirmedSteps,
        stepId,
      ];

      let blockedUIStep = false;
      if (state.actualStep && state.actualStep.blockedByAPI) {
        blockedUIStep = true;
      }

      if (unblockedUIStep) {
        blockedUIStep = false;
      }

      const newState = {
        ...state,
        confirmedSteps: newConfirmedSteps,
        blockedUIStep,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.RESET_LAST_CONFIRMED_STEP: {
      const { confirmedSteps } = state;

      confirmedSteps.pop();

      const newState = {
        ...state,
        confirmedSteps,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_SHOW_STEP_ADVICE: {
      const { adviceTitle, steps } = action.payload;

      const newState = {
        ...state,
        stepAdvice: {
          mustShow: true,
          adviceTitle,
          stepsToShow: steps,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.SET_OFFER_INFO: {
      const {
        showPersonalData,
        swap,
        poit,
      } = action.payload;
      if(showPersonalData){
        const newState = {
          ...state,
          showPersonalData: true,
          swap,
          poitReceived: poit,
        };
        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      } else {
        return {
          state: {
            ...state,
            swap,
            poitReceived: poit,
          },
          stepsMustBeEvaluated: false,
        };
      }
    }
    case commonTypes.GO_TO_PERSONAL_DATA_STEP: {
      const actualPersonalDataStep = state.flowInfo.flowJson.steps.find(step => step.isPersonalDataStep);
      const { confirmedSteps } = state;
      const newConfirmedSteps = confirmedSteps.filter(step => {
        return step !== actualPersonalDataStep.id
      });
      const newState = {
        ...state,
        actualStep: {...actualPersonalDataStep},
        confirmedSteps: newConfirmedSteps,
        blockedUIStep: true,
      };
      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case flowTypes.SET_INITIAL_FLOW_INFO: {
      const {
        process,
        productOffering,
        flowJson,
        promotion,
        isConfirmInit,
      } = action.payload;
      const flowJsonNumSteps = flowJson.steps.length - 1;

      let { actualStep } = state;

      if (isConfirmInit && flowJson.confirmationInfo && flowJson.confirmationInfo.confirmationStep) {
        actualStep = flowJson.confirmationInfo.confirmationStep;
      }

      const newState = {
        ...state,
        actualStep,
        flowInfo: {
          flowJson,
          flowJsonNumSteps,
          process,
          productOffering,
          promotion,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setBlockedUIStep: blockedUIStepState => ({
    type: types.SET_BLOCKED_UI_STEP,
    payload: blockedUIStepState,
  }),
  setShowStepAdvice: ({ adviceTitle, steps }) => ({
    type: types.SET_SHOW_STEP_ADVICE,
    payload: { adviceTitle, steps },
  }),
  resetLastConfirmedStep: () => ({
    type: types.RESET_LAST_CONFIRMED_STEP,
  }),
};

export default UINeedsStepsReducer;
